<template>
  <div>
    <nav v-if="breadcrumb" class="border-b border-gray-300 py-2 px-2 mb-4 md:px-0">
      <div class="flex justify-between items-center">
        <div class="space-y-1 m-2">
          <div class="text-xl font-semibold text-primary">
            Subscriptions
          </div>
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'subscriptions'}">Subscriptions</router-link>
          </div>
        </div>
        <div class="">

        </div>
      </div>
    </nav>
    <div class="pb-4">
      <div class="bg-white pt-4  rounded shadow">
        <div class="mx-4 my-2 text-lg">{{ title }}</div>
        <div class="flex justify-between py-2 px-4">
          <div>
            <label class="block tracking-wide text-gray-700">Records</label>
            <select v-model="recordsPerPage" @change="loadStats(currentPage)"
                    class="block appearance-none w-full bg-white border border-gray-300  px-4 py-2  rounded leading-tight focus:outline-none focus:border-gray-500">
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>250</option>
            </select>
          </div>
          <div>
            <label class="block tracking-wide text-gray-700">Search</label>
            <input v-model="searchString" @change="loadStats(currentPage)"
                   class="appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500"
                   type="text" placeholder="Search">
          </div>
        </div>
        <div class=" overflow-auto ">
          <table v-if="!loading" class="table-auto w-full">
            <thead>
            <tr class="border-b font-bold">
              <td class="px-4 py-2"></td>
              <td class="px-4 py-2">Customer</td>
              <td class="px-4 py-2">Phone Number</td>
              <td class="px-4 py-2">Service Plan</td>
              <td class="px-4 py-2">Date</td>
              <td class="px-4 py-2">Expiry</td>
              <td class="px-4 py-2">Usage</td>
              <td class="px-4 py-2">Status</td>
            </tr>
            </thead>
            <tbody>
            <tr class="border-b" v-for="(voucher,index) in subscriptions" :key="voucher.id">
              <td class="px-4 py-2">{{ index + 1 }}</td>
              <td class="px-4 py-2 ">
                <router-link :to="{name:'customer_profile', params:{customerId: voucher.customer.id}}">
                  {{ voucher.customer.identity }}
                </router-link>
              </td>
              <td class="px-4 py-2 ">
                <router-link :to="{name:'customer_profile', params:{customerId: voucher.customer.id}}">
                  {{ voucher.customer.phone_number }}
                </router-link>
              </td>
              <td class="px-4 py-2">
                <router-link :to="{name:'service_plan', params:{planId: voucher.servicePlan.id}}">
                  {{ voucher.servicePlan.name }} @ Ksh.{{ voucher.servicePlan.price }}
                </router-link>
              </td>
              <td class="px-4 py-2">{{ voucher.started_on }}</td>
              <td class="px-4 py-2">{{ voucher.expires_on }}</td>
              <td class="px-4 py-2">{{ voucher.usage }}</td>
              <td class="px-4 py-2">{{ voucher.status }}</td>

            </tr>
            </tbody>
          </table>

          <div v-else class="py-6 text-center w-full">
            <feather animation="spin" type="loader" size="32" class="mr-4"></feather>
            <p>Loading...</p>
          </div>
          <Pagination class="py-2 px-3" :total-count="vouchersCount" :current-page="currentPage"
                      :tag="'connections'" :offset="offset"
                      :records-count="subscriptions != null ? subscriptions.length || 0 : 0"
                      :click-handler="loadStats" :records-per-page="parseInt(recordsPerPage)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "../../services/graphql.service";
import Pagination from "@/components/Pagination";

export default {
  name: "Subscriptions",
  components: {Pagination},
  data() {
    return {
      searchString: '',
      recordsPerPage: this.rowsPerPage,
      subscriptions: [],
      vouchersCount: 0,
      currentPage: 1,
      loading: true
    }
  },
  props: {
    title: {type: String, default: 'Service Plan Subscriptions'},
    rowsPerPage: {type: Number, default: 10},
    breadcrumb: {default: true, type: Boolean}
  },
  mounted() { 
    this.loadStats();
  },

  computed: {
    offset: function () {
      return (this.currentPage - 1) * this.recordsPerPage;
    }
  },
  watch: {
    searchString: function () {
      this.currentPage = 1;
    },
  },
  methods: {
    loadStats(newPage) {
      this.currentPage = newPage || 1;
      this.loading = true

      let params = 'limit: ' + this.recordsPerPage + ', offset: ' + this.offset + ', order: "created_at desc", search: "' + this.searchString + '"';
      GraphQl.sendRequest('{subscriptions(' + params + ')  {customer{ id identity phone_number}  servicePlan {id price name } expires_on started_on usage status }}')
          .then(response => {
            this.subscriptions = response.subscriptions;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>

<style scoped>

</style>